import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
import api from '@/api/api'
import utils from '@/utils/utils'

import Main from '@/views/Main'
// var Main = () => import(/* webpackChunkName: "Main" */ '@/views/Main');

// var Main = import(/*webpackChunkName: "Main"*/ '@/views/Main');

import Login from '@/views/auth/Login'
// var Login = () => import(/* webpackChunkName: "Login" */ '@/views/auth/Login');

import Notification from '@/views/Notification'
// var Notification = () => import(/* webpackChunkName: "Notification" */ '@/views/Notification');

import Error from '@/views/Error'
import Unsupported from '@/views/Unsupported'
import WorkNotice from '@/views/WorkNotice'
// var Error = () => import(/* webpackChunkName: "Login" */ '@/views/Error');

import qrRoutes from '@/router/qr/qr'
import noticeRoutes from '@/router/notice/notice'
import myCstmrRoutes from '@/router/myCstmr/myCstmr'
import myScheduleRoutes from '@/router/mySchedule/mySchedule'
import faqRoutes from '@/router/faq/faq'
import mypageRoutes from '@/router/mypage/mypage'
import setRoutes from '@/router/set/set'
import orgStatusRoutes from '@/router/orgStatus/orgStatus'
import popupRoutes from '@/router/popup/popup'
import commonPopupRoutes from '@/router/commonPopup/commonPopup'
import download from '@/router/download/download'
import eduplanmapRoutes from '@/router/eduplanmap/eduplanmap'
import profileRoutes from '@/router/profile/profile'
import eduQrRoutes from '@/router/eduqr/eduqr'
import chatbot from '@/router/chatbot/chatbot'
import sampleRoutes from '@/router/sample/sample'
import bsnPlan2Routes from '@/router/mypage/bsnPlan2'
Vue.use(Router)

// function loadView(view) {
//     return () => import(`@/views/${view}`)
//   }

var router = new Router({
    mode: 'history',        // history 모드는 자연스러운 url 가능, 지정하지 않으면 해시(#)기호로 url 사용
    routes: [
        {
            path: "/main",
            // alias:['/main'],
            name: "main",
            component: Main,
            // component: () => import(/*webpackChunkName: "Main"*/ '@/views/Main'),
            meta: {
                auth: true,
                logging: true,
                pageName: '홈',
            }
        },
        {
            path: "/login",
            name: "login",
            // component: () => import(/*webpackChunkName: "Login"*/ '@/views/auth/Login'),
            component: Login,
            meta: {
                auth: false,
                logging: false,
                pageName: '로그인',
            }
        },
        {
            path: "/notification",
            name: "notification",
            // component: () => import(/*webpackChunkName: "Notification"*/ '../views/Notification'),
            component: Notification,
            // component: loadView('@/views/Notification'),
            meta: {
                auth: true,
                logging: true,
                pageName: '알림',
            }
        },
        {
            path: '/error',
            name: 'error',
            component: Error,
            // component: () => import(/*webpackChunkName: "Error"*/ '@/views/Error'),
            meta: {
                auth: false,
                logging: false,
                pageName: '오류',
            }
        },
        {
            path: '/unsupported',
            name: 'unsupported',
            component: Unsupported,
            // component: () => import(/*webpackChunkName: "Error"*/ '@/views/Error'),
            meta: {
                auth: false,
                logging: false,
                pageName: '지원안함',
            }
        },
        {
            path: '/workNotice',
            name: 'work-notice',
            component: WorkNotice,
            meta: {
                auth: false,
                logging: false,
                pageName: '작업공지',
            }
        },

        ...orgStatusRoutes,
        ...myCstmrRoutes,
        ...myScheduleRoutes,
        ...faqRoutes,
        ...mypageRoutes,
        ...setRoutes,
        ...popupRoutes,
        ...commonPopupRoutes,
        ...download,
        ...qrRoutes,
        ...noticeRoutes,
        ...eduplanmapRoutes,
        ...profileRoutes,
        ...eduQrRoutes,
        ...chatbot,
        ...sampleRoutes,
        ...bsnPlan2Routes,
        {
            path: '*',
            redirect: '/main'
        }

    ]
})

router.beforeEach((to, from, next) => {
    console.log('router.js <to>', to, to.meta.auth);
    console.log('router.js <from>', from.name);

    if(utils.nativeCom.unsupported(to.name)) {
        next('/unsupported');
        return;
    }

    var auth = to.meta.auth;
    var isLogin = store.getters.isLogin;
    if(auth) {
        try {
            console.log('router.js <isLogin>', isLogin)
            if(isLogin) {
                next();
            } else {
                next('/login');
            }
        } catch(e) {
            console.log(e);
            next('/login');
        }
    } else {
        next();
    }
  })

router.afterEach((to, from) => {
    console.log('router.js afterEach <to>', to);
    console.log('router.js afterEach <from>', from);

    if(to.name == 'unsupported') {
        return;
    }

    utils.nativeIf.outbound.routerAfterEach(to.name);

    var logging = to.meta.logging;
    if(logging) {
        var params = {};
        params.scrnNm = to.meta.pageName;
        params.scrnUrl = to.path;
        params.path = to.meta.path;
        console.log("router.js", "params", params);

        api.logging.access(params);
    }

    // 앱 버전 체크
    api.app
        .version({})
        .then(function(data) {
            console.log("router.js <api.app.version.response>", data);
            var versionInfo = data.versionInfo;
            if(versionInfo == undefined) {
                return;
            }

            var state = versionInfo.state;
            if(state == undefined) {
                return;
            }

            if(state == '0') {
                return;
            }

            var version = api.app.getAppVersion();
            if(version == '1') {
                alert('정상적인 서비스를 이용하기 위해서는 앱을 업데이트해야 합니다.');
                utils.nativeIf.outbound.outlink(versionInfo.downloadUrl);
            } else {
                utils.nativeIf.outbound.appUpdate(versionInfo.downloadUrl, versionInfo.apk, versionInfo.plist);
            }
        })
        .catch(function(error) {
            console.log(error);
        });

})
export default router

